// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zma0","title":"styles_title__3ixTf"};